// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./src/pubBiz/TabBar/index.less
// module id = 887
// module chunks = 367